/**
 * http://zpl.io/25wyd48
 */

import {Button, Icon, Menu, MenuDivider, MenuItem, Popover} from '@blueprintjs/core'
import {pluralize, Popover2, Tooltip2} from '@api'
import {useStores, useVipLocalStore, VipLocalStore, WorkspaceRelationshipMenuItems, utils, ContextMenuItem, StoresInstanceContext} from '@modules'
import {useCatalogRootFlexLayoutStore} from '@stores/catalog/flexLayout'
import {computed} from 'mobx'
import * as css from './WorkspaceChooser.css'
import {classNames, React, useAsync, observer, logJS, action, Fragment} from '@api'
import {AssortmentConfig, icons, ICustomViewCatalogConfig, IWorkspacePreset, nav, StoresInstance, ui, Workspace, WorkspaceConfig} from '@stores'

export type ClickWorkspaceEventArgs = { workspace: WorkspaceConfig, preset?: IWorkspacePreset, assortment?: AssortmentConfig }
export type ClickWorkspaceHandler = (e: React.FormEvent, params: ClickWorkspaceEventArgs) => void

export class WorkspaceChooserStore extends VipLocalStore {
//this.chooserStore = new WorkspaceChooserStore(catalog.workspaceStores)
//
  constructor(stores: StoresInstance) {
    super(stores)
    stores.workspaces.chooserStore = this
  }

  @computed get otherWorkspaces() {
    const {stores: {workspaces: {availableWorkspaces, wrapperById, current}}} = this
    return availableWorkspaces.filter(ws => ws._id != current && wrapperById[ws._id]?.visible)
  }

  @action onClickWorkspaceItem = (e: React.FormEvent, {workspace}: { workspace: WorkspaceConfig }) => {
    // Prevent default behavior or else react-router won't update smoothly
    e.stopPropagation()
    e.preventDefault()
    this.stores.presets.loadPreset(workspace, null, true)
  }
}

export const useWorkspaceChooserStore = () => {
  return useVipLocalStore(ws => new WorkspaceChooserStore(ws))
}

export const WorkspaceChooser = observer<{ className?: string }>(function WorkspaceChooser({className}) {
  const {
    workspaces,
    workspaces: {workspaceConfig, deploymentConfig, availableWorkspaces, getWorkspaceLastSync},
    presets: {matchingPreset},
    contextMenu,
    catalog: {itemCount, isGlobalStore}
  } = useStores()

  return (
    <div className={classNames(className, css.selectorRoot)} data-type='WorkspaceChooser' data-workspace={workspaceConfig?._id} onContextMenu={() => {
      contextMenu.ignoreThisContextMenuEvent = true
    }}>
      <div className={css.selectContainer}>
        {deploymentConfig &&
		 <Popover2 position='bottom-left'
		           interactionKind='click'
		           disabled={availableWorkspaces.length === 1 && !availableWorkspaces[0]?.customViews}
		           modifiers={{arrow: {enabled: false}}}
		           usePortal
		           content={
                     <Menu className={css.bpMenu}>
                       <WorkspaceChooserMenuItems/>
                     </Menu>}
		 >
			 <Button minimal
			         rightIcon={availableWorkspaces.length > 1 || availableWorkspaces[0]?.customViews ? 'caret-down' : undefined}>
               {workspaceConfig?.title ?? workspaces.current}{isGlobalStore ? null : (itemCount != null && ` (${itemCount})`)}
               {false && matchingPreset && <Fragment>
                 {/*<Icon icon='arrow-right' className={css.rightArrowIcon} />*/}
				   <span className={css.customView}>{matchingPreset.label}</span>
			   </Fragment>}
			 </Button>
		 </Popover2>
        }
      </div>
    </div>
  )
})
/*

export const WorkspaceChooserMenuItems2 = observer(function WorkspaceChooserMenu() {
  const {
      workspaces: {availableWorkspaces, currentConfig, current},
      catalog: {itemCountFor}
    } = stores,
    {onClickWorkspaceItem, otherWorkspaces} = useWorkspaceChooserStore()

  return (
    <Fragment>
      {currentConfig &&
	   <Fragment>
		   <MenuDivider title={currentConfig.title ?? currentConfig._id}/>
		   <MenuItem text='Default View' href={nav.urlForWorkspace({workspace: currentConfig}, true)}/>
		   <WorkspacePresetMenuItems workspace={currentConfig}/>
	   </Fragment>}
      {otherWorkspaces.length > 1 && <Fragment>
		  <MenuDivider title={`Other Workspaces`}/>
        {otherWorkspaces?.filter(ws => ws.visible !== false && ws.catalog?.index)?.map(
          (workspace, i) => {
            if (_.isEmpty(workspace)) return <MenuDivider key={i}/>

            const {_id, catalog: {index}} = workspace
            return (
              <Fragment key={_id}>
                <MenuItem
                  className={_id == current && css.bold}
                  text={workspace.title}
                  label={`(${itemCountFor(index) ?? '...'})`}
                  href={nav.urlForWorkspace({workspace}, true)}
                  onClick={onClickWorkspaceItem(workspace)}
                  children={_.isEmpty(workspace?.customViews) ? undefined :
                            <Fragment>
                              {/!*<MenuDivider title={strings.presets}/>*!/}
                              <WorkspacePresetMenuItems workspace={workspace}/>
                            </Fragment>}
                  //labelElement={count != null && (value == 'MerchOptions' || field != undefined)  && <div>({count})</div> }
                />
              </Fragment>)
          })}
	  </Fragment>}
    </Fragment>)
})
*/

type WorkspaceChooserMenuItemsProps = { hideSaveAsPreset?: boolean, showSelected?: boolean, shouldDismissPopover?: boolean, onClickWorkspaceItem?: ClickWorkspaceHandler }

export const WorkspaceChooserMenuItems = observer<WorkspaceChooserMenuItemsProps>(function WorkspaceChooserMenu({hideSaveAsPreset, shouldDismissPopover, ...props}) {
  const stores = useStores(),
    {
      flexLayout: {flexEnabled, activeCatalogRoot, isMaximized},
      deployments: {deploymentConfig}
    } = stores,
    wsChooserStore = useWorkspaceChooserStore(),
    catalogFlexLayoutTab = useCatalogRootFlexLayoutStore()

  // We might be in a specific tab, maximized and not in the flex layout tab react tree at all (site header), or right clicked on a maximized tab

  const contextStores = (flexEnabled ? isMaximized ? activeCatalogRoot?.stores : catalogFlexLayoutTab?.stores : stores) ?? stores,
    onClickWorkspaceItem = props.onClickWorkspaceItem ?? contextStores?.flexLayoutCatalogRoot?.onSwitchTabWorkspace ?? wsChooserStore.onClickWorkspaceItem

  if (!onClickWorkspaceItem) return null

  const {catalog: {itemCountFor}, deployments: {deploymentConfig: {workspaceMenuHierarchy}}, workspaces, workspaces: {availableWorkspaces, wrapperById, byId, current}} = contextStores,
    sortedWorkspaces = availableWorkspaces?.filter(ws => wrapperById[ws._id].visible && ws.catalog?.index) ?? [],
    activeWorkspace = sortedWorkspaces.find(ws => ws._id === current)

  if (!_.isEmpty(workspaceMenuHierarchy)) {
    const workspaceMap = _.keyBy(sortedWorkspaces, ws => ws._id)

    return <StoresInstanceContext.Provider value={contextStores}>
      {workspaceMenuHierarchy.map(({label, icon, workspaceIds}, i) => {
        return <Fragment key={i}>
          <MenuItem text={label} icon={icon} onClick={e => {
            const workspaceId = _.first(workspaceIds),
              ws = byId[workspaceId]

            ws && onClickWorkspaceItem(e, {workspace: ws})
          }}>
          {workspaceIds.map((id, i) => {
            const ws = workspaceMap[id]
            if (!ws) {
              // Workspace was already used elsewhere in the hierarchy
              // console.warn(`Unable to find categorized ws ${id}`, workspaceMap)
              return null
            }
            // console.log({label, id, ws})
            delete workspaceMap[id]
            return <WorkspaceChooserMenuItem key={id} {...props} workspace={ws} onClickWorkspaceItem={onClickWorkspaceItem}/>
          })}
          </MenuItem>
        </Fragment>
      })}
      {_.size(workspaceMap) > 0 && <Fragment>
		  <MenuDivider title='Other Workspaces'/>
        {_.keys(workspaceMap).map((id, i) => <WorkspaceChooserMenuItem key={id} {...props} workspace={workspaceMap[id]} onClickWorkspaceItem={onClickWorkspaceItem}/>)}
	  </Fragment>}
    </StoresInstanceContext.Provider>
  }

  return (
    <StoresInstanceContext.Provider value={contextStores}>
      {sortedWorkspaces?.map(
        (workspace, i) => {
          return <WorkspaceChooserMenuItem key={workspace._id} {...props} workspace={workspace} onClickWorkspaceItem={onClickWorkspaceItem}/>
        })}
    </StoresInstanceContext.Provider>)
})

export const WorkspaceChooserMenuItem = observer<{ workspace: WorkspaceConfig } & WorkspaceChooserMenuItemsProps>(function WorkspaceChooserMenuItem({workspace, ...props}) {
  const {workspaces: {current, wrapperById}, catalog: {itemCountFor}} = useStores(),
    {shouldDismissPopover, onClickWorkspaceItem, hideSaveAsPreset, showSelected} = props,
    catalogFlexLayoutTab = useCatalogRootFlexLayoutStore()

  if (_.isEmpty(workspace)) return <MenuDivider/>

  const {_id, catalog: {index}} = workspace,
    active = props.showSelected !== false && _id == current,
    ws = wrapperById[_id],
    count = itemCountFor(index),
    showSubmenu = !_.isEmpty(workspace?.customViews) || !_.isEmpty(ws.presets) || !_.isEmpty(ws.catalog?.catalogConfig?.assortments)

  return (
    <Fragment key={_id}>
      <ContextMenuItem
        shouldDismissPopover={shouldDismissPopover !== false}
        className={css.workspace}
        data-active={active}
        icon={!showSelected ? undefined : active ? 'tick' : 'blank'}
        text={workspace.title}
        label={count ? `(${count})` : undefined}
        // href={nav.urlForWorkspace({workspace}, true)}
        onClick={e => {
          onClickWorkspaceItem(e, {workspace})
        }}
        children={/*catalogFlexLayoutTab ? undefined :*/ !showSubmenu ? undefined : <Fragment>
          {/*<MenuDivider title={strings.presets}/>*/}
          <WorkspaceChooserAssortments workspace={workspace} onClickWorkspaceItem={onClickWorkspaceItem}/>
          <WorkspacePresetMenuItems hideSaveAsPreset={hideSaveAsPreset} onClickWorkspaceItem={onClickWorkspaceItem} workspace={workspace} shouldDismissPopover={shouldDismissPopover}/>
          {!catalogFlexLayoutTab && <WorkspaceRelationshipMenuItems dividerBefore workspace={ws}/>}
        </Fragment>}
        //labelElement={count != null && (value == 'MerchOptions' || field != undefined)  && <div>({count})</div> }
      />
    </Fragment>)
})

export const WorkspaceChooserAssortmentMenuItem = observer<{ assortment: AssortmentConfig, onClickWorkspaceItem: ClickWorkspaceHandler, workspace: WorkspaceConfig, dividerAfter?: boolean }>(
  function WorkspaceChooserAssortmentMenuItem({onClickWorkspaceItem, dividerAfter, workspace, assortment, workspace: {customViews}}) {

    const {isGlobalStore, catalog: {settings}} = useStores()

    if (isGlobalStore) return null

    const {assortment: { id: selectedAssortmentID }} = settings

    return <ContextMenuItem text={assortment.title ?? 'Assortment'}
                            shouldDismissPopover
                            icon={assortment._id === selectedAssortmentID ? 'tick' : 'blank'}
                            onClick={(e) => {
                              onClickWorkspaceItem(e, {workspace, assortment})
                            }}/>
  })

export const WorkspaceChooserAssortments = observer<{ onClickWorkspaceItem: ClickWorkspaceHandler, workspace: WorkspaceConfig, dividerAfter?: boolean }>(function WorkspaceChooserAssortments({dividerAfter, ...props}) {
  if (!props.workspace) return null

  const {catalog} = props.workspace, {strings, catalog: {assortments}} = useStores()

  if (_.isEmpty(catalog?.assortments)) return null

  return (<React.Fragment>
    {catalog.assortments.map((a, i) => <WorkspaceChooserAssortmentMenuItem key={i} assortment={a} {...props} />)}
    {assortments?.selectedAssortment && <Fragment>
		<MenuDivider/>
		<ContextMenuItem
			icon={icons.clear}
			text={strings.clear}
			onClick={() => assortments.selectedAssortment = null}/>
	</Fragment>}
  </React.Fragment>)
})
export const WorkspacePresetMenuItems = observer<{ hideSaveAsPreset?: boolean, shouldDismissPopover?: boolean, onClickWorkspaceItem?: ClickWorkspaceHandler, workspace: WorkspaceConfig, dividerAfter?: boolean }>(
  function WorkspacePresetMenuItems({hideSaveAsPreset, shouldDismissPopover, onClickWorkspaceItem, dividerAfter, workspace, workspace: {customViews}}) {
    const {strings, workspaces, currentUser, users, presets, presets: {selectedPreset, clearPreset, matchingPreset, selectedPresetId, loadPreset}} = useStores(),
      {presets: wsPresets, catalog} = workspaces.workspaceFor(workspace._id),
      isCurrentWorkspace = workspace._id === workspaces.workspace?.id

    //todo - move components to real children, these all rerender anytime we change selected preset
    //  logJS({customViews, wsPresets})
    return (
      <Fragment>
        {selectedPreset && <ContextMenuItem icon='blank' text='Unload Preset' dividerAfter onClick={clearPreset}/>}
        {_.isEmpty(customViews) && _.isEmpty(wsPresets) && <ContextMenuItem icon='blank' text='No Presets'/>}
        {(customViews ?? []).map(  // Legacy custom views written into the config directly (not saved as presets in the DB)
          (cv, j) => {
            const {divider, label, icon} = cv
            return <Fragment key={j}>
              {divider
               ? <MenuDivider title={label}/>
               : <ContextMenuItem
                 key={j}
                 shouldDismissPopover={shouldDismissPopover}
                 text={label ?? strings.noValue}
                 className={css.preset}
                 icon={matchingPreset === cv ? 'tick' : 'blank'}
                 data-selected={matchingPreset === cv}
                 onClick={(e) => {
                   if (onClickWorkspaceItem) {
                     onClickWorkspaceItem(e, {workspace, preset: cv})
                   } else {
                     loadPreset(workspace, cv)
                   }
                 }}
               />
              }
            </Fragment>
          })}
        {!_.isEmpty(wsPresets) && <Fragment>
          {!_.isEmpty(customViews) && <MenuDivider/>}
          {wsPresets.map((preset, i) => {  // User defined presets
            return (
              <ContextMenuItem
                key={i}
                className={css.preset}
                text={<div className={css.presetText}>
                  <label>{preset.label}</label>
                  {/*{preset.creator === users.current?.id && <Tooltip2 content='Created by You'>*/}
                  {/*  <div className={css.mine}><Icon icon='user'/></div>*/}
                  {/*</Tooltip2>}*/}
                  {preset.public && <div className={css.public} title={`Shared by ${users.getById(preset.creator)?.name}`}><Icon icon='people'/></div>}
                </div>}
                icon={preset._id === selectedPresetId ? 'tick' : 'blank'}
                onClick={(e) => {
                  if (onClickWorkspaceItem) {
                    onClickWorkspaceItem(e, {workspace, preset})
                  } else {
                    presets.loadPresetForCurrentWorkspace(preset)
                  }
                }}
              >
              </ContextMenuItem>) // {false && preset && preset.creator === currentUser?.info?.id && <ContextMenuItem dividerBefore text='Delete this Preset' icon='trash' onClick={() => deletePreset(preset)} shouldDismissPopover={false}/>}
          })}
		</Fragment>}
        {isCurrentWorkspace && !hideSaveAsPreset &&
		 <Fragment>
           {!_.isEmpty(wsPresets) && <MenuDivider/>}
       {presets.isDirty && <SaveDirtyPresetMenuItem />}
			 <SaveCurrentCatalogAsPresetMenuItem/>
		 </Fragment>}

        {dividerAfter && (!_.isEmpty(customViews) || isCurrentWorkspace) && <MenuDivider/>}
      </Fragment>)
  })

export const SaveDirtyPresetMenuItem = observer(function SaveDirtyPresetMenuItem() {
  const {catalog: {presets: {selectedPreset, isDirty, saveCurrentPreset}}, users:{ user: {id: userId}}} = useStores()

  if (!isDirty) return null

  return <MenuItem icon='saved'
                   text={`Save Changes to '${selectedPreset.label}'`}
                   disabled={selectedPreset.creator !== userId}
                   onClick={saveCurrentPreset}
                   shouldDismissPopover={true}/>
})

export const SaveCurrentCatalogAsPresetMenuItem = observer(function SaveCurrentCatalogAsPresetMenuItem({}) {
  const {catalog: {presets}} = useStores()

  return <MenuItem icon='saved'
                   text={presets.selectedPreset ? 'Save Preset As...' : 'Save Preset'}
                   onClick={() => presets.startCreateNewPreset()} shouldDismissPopover={true}/>
})

export const SwitchCurrentCatalogPresetMenuItem = observer<{ onClickWorkspaceItem?: ClickWorkspaceHandler }>(function SwitchCurrentCatalogPresetMenuItem({onClickWorkspaceItem}) {
  const store = useCatalogRootFlexLayoutStore()

  if (!store) {
    return null
  }
  const {stores: {workspace}} = store
  return (<React.Fragment>
    <ContextMenuItem text='Switch to Preset' icon='swap-horizontal' disabled={_.isEmpty(workspace.presets)}>
      {_.isEmpty(workspace.presets) ? undefined : <WorkspacePresetMenuItems shouldDismissPopover workspace={workspace?.config} onClickWorkspaceItem={onClickWorkspaceItem}/>}
    </ContextMenuItem>
  </React.Fragment>)
})



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/WorkspaceChooser.tsx